export enum Feature {
	APPOINTMENT_MANAGEMENT = 'APPOINTMENT_MANAGEMENT',
	APPOINTMENT_REPORT = 'APPOINTMENT_REPORT',
	APPS = 'APPS',
	GROUP_APPOINTMENTS = 'GROUP_APPOINTMENTS',
    CALENDAR_SYNC = 'CALENDAR_SYNC',
    EXPERIENCE_SELECTOR = 'EXPERIENCE_SELECTOR',
    FLOWS = 'FLOWS',
    INSTANT_BOOKING = 'INSTANT_BOOKING',
    PERMISSIONS = 'PERMISSIONS',
    PERSONAL_ACCESS_TOKEN = 'PERSONAL_ACCESS_TOKEN',
    REMOVE_BRANDING = 'REMOVE_BRANDING',
    RESERVATION = 'RESERVATION',
    SERVICE_HOURS = 'SERVICE_HOURS',
    ADMIN_DRAFT_ORDER_WITHOUT_BOOKING = 'ADMIN_DRAFT_ORDER_WITHOUT_BOOKING',
    CUSTOMER_MANAGEMENT = 'CUSTOMER_MANAGEMENT',
    CALENDAR_ALL_LOCATIONS = 'CALENDAR_ALL_LOCATIONS',
}
